import { Graphics } from 'pixi.js';
import type { World, ComponentStore } from '@ecs/world';
import type { CameraResource, ProjectileComponent, TransformComponent, VelocityComponent } from '@game/scenes/characterPrototype/types';

export type ProjectileSpawnDefaults = {
	defaultLifetime: number;
	defaultSize: number;
	defaultFill: number;
	defaultStroke: number;
};

export function createSpawnProjectile(defaults: ProjectileSpawnDefaults) {
	return function spawnProjectile(
		world: World,
		transforms: ComponentStore<TransformComponent>,
		velocities: ComponentStore<VelocityComponent>,
		projectiles: ComponentStore<ProjectileComponent>,
		graphics: ComponentStore<Graphics>,
		stage: import('pixi.js').Application['stage'],
		x: number,
		y: number,
		vx: number,
		vy: number,
		options?: {
			fromEnemy?: boolean;
			lifetime?: number;
			size?: number;
			fill?: number;
			stroke?: number;
		}
	) {
		const entity = world.createEntity();
		transforms.set(entity, { x, y });
		velocities.set(entity, { x: vx, y: vy });
		const size = options?.size ?? defaults.defaultSize;
		projectiles.set(entity, {
			lifetime: options?.lifetime ?? defaults.defaultLifetime,
			fromEnemy: !!options?.fromEnemy,
			size
		});
		const camera = world.getResource<CameraResource>('camera');
		const offsetY = camera ? camera.y : 0;
		const graphic = new Graphics();
		graphic.circle(0, 0, size / 2);
		graphic.fill({ color: options?.fill ?? defaults.defaultFill, alpha: 0.95 });
		graphic.stroke({ color: options?.stroke ?? defaults.defaultStroke, alpha: 0.8, width: 1.5 });
		graphic.position.set(x, y - offsetY);
		stage.addChild(graphic);
		graphics.set(entity, graphic);
	};
}


